import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade show active border border-top-0",
  id: "panel-pub-paper",
  role: "tabpanel",
  "aria-labelledby": "tab-pub-paper"
}
const _hoisted_2 = { class: "container p-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(": BibTeX information ")
const _hoisted_4 = { class: "list-group" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Preprint. ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(".) ")
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["data-bs-target"]
const _hoisted_17 = ["id", "aria-labelledby"]
const _hoisted_18 = { class: "modal-dialog modal-lg" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = ["id"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_23 = { class: "modal-body" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fa-solid', 'file-export'] }),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.papers, (paper, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "list-group-item"
          }, [
            _createElementVNode("h5", {
              class: "mb-1",
              innerHTML: `[${_ctx.papers.length - index}] ${paper.title}`
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: "mb-0",
                  innerHTML: paper.author
                }, null, 8, _hoisted_7),
                _createElementVNode("p", _hoisted_8, [
                  (paper.hasOwnProperty('journal'))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("a", {
                          href: paper.url,
                          target: "_blank"
                        }, _toDisplayString(paper.journal) + " " + _toDisplayString(paper.volume) + ", " + _toDisplayString(paper.page) + " (" + _toDisplayString(paper.year) + ")", 9, _hoisted_9),
                        _hoisted_10
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_11
                      ], 64)),
                  _hoisted_12,
                  _createElementVNode("a", {
                    href: `https://arxiv.org/abs/${paper.arxiv}`,
                    target: "_blank"
                  }, "arXiv:" + _toDisplayString(paper.arxiv), 9, _hoisted_13),
                  _hoisted_14
                ]),
                (paper.hasOwnProperty('note'))
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "mb-0",
                      innerHTML: paper.note
                    }, null, 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": `#pub-paper-${_ctx.papers.length - index}-bib`
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "big",
                  icon: ['fa-solid', 'file-export']
                })
              ], 8, _hoisted_16)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.papers, (paper, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "modal fade",
            id: `pub-paper-${_ctx.papers.length - index}-bib`,
            tabindex: "-1",
            "aria-labelledby": `pub-paper-${_ctx.papers.length - index}-bib-label`,
            "aria-hidden": "true"
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h5", {
                    class: "modal-title",
                    id: `pub-paper-${_ctx.papers.length - index}-bib-label`
                  }, "Get BibTeX", 8, _hoisted_21),
                  _hoisted_22
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("textarea", {
                    class: "form-control form-control-sm",
                    rows: "15",
                    readonly: "",
                    innerHTML: paper.bibtex
                  }, null, 8, _hoisted_24)
                ]),
                _hoisted_25
              ])
            ])
          ], 8, _hoisted_17))
        }), 128))
      ])
    ])
  ]))
}